module.exports = __webpack_public_path__ + "img/logo-white-transparent.aa2b2b2c.png";